import { StatusAverbacao, TipoDesconto, ModalidadePrestacaoTarefa, StatusPrestacaoTarefa } from '../models/tempo-servico.model';

export const TEMPO_SERVICO_TCDF_CATEGORIAS = [
  {
    id: 7,
    idTcdf: 7,
    naturezaTempoAverbado: 'Atividade privada urbana',
    regimeJuridico: 'Celetista (RGPS)',
    esfera: 'Iniciativa Privada',
    ponderado: false,
    isDefault: true,
    ativo: true,
    tipoPmdf: { id: 3, codigoPmdf: 3, descricao: 'Tempo Averbado', ativo: true }
  },
  {
    id: 9,
    idTcdf: 9,
    naturezaTempoAverbado: 'Militar das Forças Armadas',
    regimeJuridico: 'Militar',
    esfera: 'Federal',
    ponderado: false,
    isDefault: false,
    ativo: true,
    tipoPmdf: { id: 1, codigoPmdf: 1, descricao: 'Tempo Forças Armadas', ativo: true }
  },
  {
    id: 10,
    idTcdf: 10,
    naturezaTempoAverbado: 'Polícia Militar e Corpo de Bombeiros Militar',
    regimeJuridico: 'Militar',
    esfera: 'Distrital',
    ponderado: false,
    isDefault: false,
    ativo: true,
    tipoPmdf: { id: 1, codigoPmdf: 1, descricao: 'Tempo Forças Armadas', ativo: true }
  },
  {
    id: 16,
    idTcdf: 16,
    naturezaTempoAverbado: 'Empresa pública ou sociedade de economia mista',
    regimeJuridico: 'Celetista (RGPS)',
    esfera: 'Distrital',
    ponderado: false,
    isDefault: false,
    ativo: true,
    tipoPmdf: { id: 2, codigoPmdf: 2, descricao: 'Tempo Averbado Público', ativo: true }
  }
];

export const TEMPO_SERVICO_AVERBACOES = [
  {
    id: 'a1b2c3d4-e5f6-7a8b-9c0d-1e2f3a4b5c6d',
    tipoTempoTcdf: TEMPO_SERVICO_TCDF_CATEGORIAS[0],
    dataInicio: '2010-01-01',
    dataFim: '2012-06-30',
    duracao: { anos: 2, meses: 5, dias: 29 },
    processoSei: '00054.000123/2024-12',
    numeroDocumento: 'Certidão INSS 49201',
    nomeEmpresa: 'Tecnologia Avançada S.A.',
    cnpjEmpresa: '12.345.678/0001-99',
    observacao: 'Averbação de tempo RGPS homologada pelo TCDF.',
    certidaoUrl: 'assets/certidao_tempo_externo.pdf',
    nomeAnexo: 'certidao_inss_joao.pdf',
    status: StatusAverbacao.APROVADA,
    aprovadoPor: 'Maj PM Roberto Silva',
    aprovadoEm: '2024-03-15T14:30:00Z',
    criadoPor: 'Sgt PM Carlos Souza',
    criadoEm: '2024-03-10T10:00:00Z'
  },
  {
    id: 'f8g9h0i1-j2k3-4l5m-6n7o-8p9q0r1s2t3u',
    tipoTempoTcdf: TEMPO_SERVICO_TCDF_CATEGORIAS[1],
    dataInicio: '2008-03-10',
    dataFim: '2009-03-10',
    duracao: { anos: 1, meses: 0, dias: 0 },
    processoSei: '00054.000987/2024-44',
    numeroDocumento: 'Certidão de Reservista Exército 881',
    nomeEmpresa: 'Exército Brasileiro - 11º BIMtz',
    cnpjEmpresa: '00.394.452/0001-02',
    observacao: 'Tempo de serviço militar obrigatório nas Forças Armadas.',
    certidaoUrl: 'assets/reservista_joao.pdf',
    nomeAnexo: 'reservista_eb.pdf',
    status: StatusAverbacao.PENDENTE,
    criadoPor: 'Sgt PM Carlos Souza',
    criadoEm: '2026-05-20T09:15:00Z'
  }
];

export const TEMPO_SERVICO_FICHA_DEFAULT = {
  matricula: '123456',
  nomeCompleto: 'Cap PM João da Silva Oliveira',
  postoGraduacao: 'CAPITÃO',
  quadro: 'QPPMC',
  dataAdmissao: '2013-02-01',
  dataNascimento: '1985-07-15',
  tempoEfetivoServico: { anos: 13, meses: 3, dias: 24 },
  totalAnosServico: { anos: 15, meses: 9, dias: 23 },
  tempoEm31122019: { anos: 6, meses: 10, dias: 30 },
  pedagio17Porcento: { anos: 4, meses: 9, dias: 12 },
  dataProjetadaReserva: '2048-02-01',
  dataReservaComPedagio: '2046-04-18',
  indicadorDireitoAdquirido: false,
  descontos: [
    {
      id: 'desc-1',
      tipo: TipoDesconto.LTIP,
      dataInicio: '2018-05-01',
      dataFim: '2018-11-01',
      duracao: { anos: 0, meses: 6, dias: 0 },
      justificativa: 'Licença para Tratar de Interesse Particular',
      baseLegal: 'Art. 27, Lei 12.086/2009',
      dominioOrigem: 'Afastamentos'
    }
  ],
  averbacoes: TEMPO_SERVICO_AVERBACOES,
  periodosReservaIndevida: [
    {
      id: 'indev-1',
      dataInicioReserva: '2025-01-01',
      dataRetornoAtiva: '2025-03-15',
      totalPausa: { anos: 0, meses: 2, dias: 14 },
      processoSei: '00054.000551/2025-99',
      motivo: 'Reversão de transferência para reserva indevida'
    }
  ],
  periodosPptcDsa: [
    {
      id: 'pptc-1',
      modalidade: ModalidadePrestacaoTarefa.PPTC,
      dataInicio: '2025-06-01',
      dataFim: '2026-06-01',
      totalTempo: { anos: 1, meses: 0, dias: 0 },
      status: StatusPrestacaoTarefa.ATIVO
    }
  ]
};

export const TEMPO_SERVICO_DASHBOARD_POSICAO = {
  totalPmsAtivos: 8520,
  pmsDireitoAdquirido: 148,
  pmsMenos1Ano: 324,
  pms1a3Anos: 612,
  pms3a5Anos: 945,
  tempoMedioServico: { anos: 18, meses: 4, dias: 15 },
  averbacoesPendentes: TEMPO_SERVICO_AVERBACOES.filter(a => a.status === StatusAverbacao.PENDENTE).length,
  distribuicaoTempoRestante: [
    { label: 'Direito Adquirido', valor: 148 },
    { label: '0 a 1 ano', valor: 324 },
    { label: '1 a 3 anos', valor: 612 },
    { label: '3 a 5 anos', valor: 945 },
    { label: '5 a 10 anos', valor: 1840 },
    { label: '10+ anos', valor: 4651 }
  ],
  distribuicaoIdade: [
    { label: '18-25', valor: 850 },
    { label: '26-35', valor: 2840 },
    { label: '36-45', valor: 3120 },
    { label: '46-55', valor: 1510 },
    { label: '56+', valor: 200 }
  ],
  distribuicaoPostoGraduacao: [
    { label: 'Oficiais Superiores', valor: 350 },
    { label: 'Oficiais Intermediários', valor: 890 },
    { label: 'Subtenentes e Sargentos', valor: 3120 },
    { label: 'Cabos e Soldados', valor: 4160 }
  ],
  distribuicaoQuadro: [
    { label: 'QPPMC (Combatentes)', valor: 7850 },
    { label: 'QOPMS (Saúde)', valor: 280 },
    { label: 'QOPMA (Administração)', valor: 310 },
    { label: 'QOPME (Especialistas)', valor: 80 }
  ]
};

export const TEMPO_SERVICO_DASHBOARD_PROJECOES = {
  projecao12Meses: [
    { periodo: 'Jun/26', quantidade: 28, acumulado: 28 },
    { periodo: 'Jul/26', quantidade: 32, acumulado: 60 },
    { periodo: 'Ago/26', quantidade: 19, acumulado: 79 },
    { periodo: 'Set/26', quantidade: 45, acumulado: 124 },
    { periodo: 'Out/26', quantidade: 27, acumulado: 151 },
    { periodo: 'Nov/26', quantidade: 38, acumulado: 189 }
  ],
  projecao5Anos: [
    { periodo: '2026', quantidade: 324, acumulado: 324 },
    { periodo: '2027', quantidade: 412, acumulado: 736 },
    { periodo: '2028', quantidade: 490, acumulado: 1226 },
    { periodo: '2029', quantidade: 580, acumulado: 1806 },
    { periodo: '2030', quantidade: 615, acumulado: 2421 }
  ],
  projecao10Anos: [
    { periodo: '2026-2030', quantidade: 2421, acumulado: 2421 },
    { periodo: '2031-2035', quantidade: 3180, acumulado: 5601 }
  ],
  impactoPorOpm: [
    { opmId: 'opm1', opmNome: '1º BPM (Asa Sul)', quantidade1Ano: 14, quantidade3Anos: 28, quantidade5Anos: 48 },
    { opmId: 'opm2', opmNome: '2º BPM (Taguatinga)', quantidade1Ano: 18, quantidade3Anos: 39, quantidade5Anos: 64 },
    { opmId: 'opm3', opmNome: '4º BPM (Guará)', quantidade1Ano: 9, quantidade3Anos: 22, quantidade5Anos: 35 }
  ],
  impactoPorPosto: [
    { label: 'Coronel', valor: 25 },
    { label: 'Tenente-Coronel', valor: 45 },
    { label: 'Major', valor: 85 },
    { label: 'Capitão', valor: 120 },
    { label: 'Subtenente', valor: 310 },
    { label: 'Sargento', valor: 650 }
  ],
  curvaEnvelhecimento: [
    { periodo: '2026', quantidade: 37, acumulado: 37 },
    { periodo: '2028', quantidade: 39, acumulado: 39 },
    { periodo: '2030', quantidade: 41, acumulado: 41 }
  ],
  projecaoDeficitEfetivo: [
    { periodo: '2026', quantidade: -250, acumulado: -250 },
    { periodo: '2027', quantidade: -610, acumulado: -610 },
    { periodo: '2028', quantidade: -1100, acumulado: -1100 }
  ]
};

export const TEMPO_SERVICO_MACRO_PROJECAO_DEFAULT = [
  { ano: 2026, efetivoAtivo: 8520, saidasReserva: 324, entradasConcurso: 0, distribuicaoPosto: [], distribuicaoQuadro: [], distribuicaoIdade: [], distribuicaoSexo: [] },
  { ano: 2027, efetivoAtivo: 8196, saidasReserva: 412, entradasConcurso: 0, distribuicaoPosto: [], distribuicaoQuadro: [], distribuicaoIdade: [], distribuicaoSexo: [] },
  { ano: 2028, efetivoAtivo: 7784, saidasReserva: 490, entradasConcurso: 0, distribuicaoPosto: [], distribuicaoQuadro: [], distribuicaoIdade: [], distribuicaoSexo: [] }
];
